import { render, staticRenderFns } from "./KnowlegeReport.vue?vue&type=template&id=11dc47e9&scoped=true"
import script from "./KnowlegeReport.vue?vue&type=script&lang=js"
export * from "./KnowlegeReport.vue?vue&type=script&lang=js"
import style0 from "./KnowlegeReport.vue?vue&type=style&index=0&id=11dc47e9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dc47e9",
  null
  
)

export default component.exports